import * as React from 'react';
import { ErrorWrapper } from '../ErrorWrapper';
import { DENIED_BY_SANCTIONS_LINK } from './constants';
import { forbiddenIcon } from '../../icons';
import { Link } from '../../../../../common/Link';

export const DeniedBySanctions = () => (
  <ErrorWrapper icon={forbiddenIcon}>
    Вы не можете продвигать объявление в поиске из-за ограничений от модерации.{' '}
    <Link href={DENIED_BY_SANCTIONS_LINK} target="_blank" rel="noreferrer">
      Подробнее
    </Link>
  </ErrorWrapper>
);
